import React from 'react';
import { Bar } from 'react-chartjs-2';

function BarWindowJohari({ item }) {
  const data = {
    labels: [item?.primary, item?.secondary, item?.tertiary, item?.fourth],
    datasets: [
      {
        data: [item?.primary, item?.secondary, item?.tertiary, item?.fourth],
        backgroundColor: [
          'rgba(68, 114, 196, 1)',
          'rgba(238, 125, 48, 1)',
          'rgba(147, 147, 147, 1)',
          'rgba(255, 191, 0, 1)',
        ],
      },
    ],
  };
  const options = {
    indexAxis: 'y',
    scales: {
      x: {
        max: 25,
      },
      y: {
        beginAtZero: false,
        max: 25,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: 'Gráfico de Barras Horizontal',
      },
    },
  };

  return <Bar data={data} options={options} />;
}

export default BarWindowJohari;
